<!-- results-table.component.html -->
<h1 mat-dialog-title><strong>Seleccionar </strong> {{nombreDueno}}</h1>

<div mat-dialog-content>

  <div fxFlex>
    <mat-form-field fxFlex>
      <mat-label>{{nombreDueno}}</mat-label>
      <mat-select [(ngModel)]="usuario" class="roleSelect">
        <ng-container *ngFor="let usuario of usuarios">
          <mat-option *ngIf="esOwnersGroup(usuario)" [value]="usuario">
            {{usuario.nombreCompleto}}
          </mat-option>
        </ng-container>
        <!--
          <mat-option *ngFor="let usuario of evaluacion.nodoEstructuraJerarquica.usuarios" *ngIf="esOwnersGroup(usuario)" [value]="usuario">
              {{usuario.nombreCompleto}}
          </mat-option>
          -->
      </mat-select>
    </mat-form-field>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="doAction()">Aceptar</button>
  <button mat-button (click)="closeDialog()" mat-flat-button color="warn">Cancelar</button>
</div>
